//import { Service } from '../../../store/data/types';
import { Box, Chip, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, ListItemText, MenuItem, Select, SelectChangeEvent, Checkbox, InputLabel } from '@mui/material';
import UpTransition from '../../../shared/UpTransition/UpTransition';
//import { createIconFromName } from '../../../util/iconUtil';
import { useState } from 'react';
//import parameterSelector, { SelectedValueType } from '../AddServiceDialog/parameter/parameterSelector';
//import useComplexObject from '../AddServiceDialog/parameter/useComplexObject';
import ErrorTypography from '../../../shared/ErrorTypography/ErrorTypography';
//import { ParameterValidatorService } from '../AddServiceDialog/parameter/parameterValidatorService';
import { Trans, useTranslation } from 'react-i18next';
import { Graph as GraphType } from '../../../store/data/types';
//import { IEdge, INode } from 'react-digraph';

type Props = {
  open: boolean;
  graphInfo: GraphType | null;
onClose: (success: boolean, ServicesFrom: string, ServicesTo: string[]) => void;
};

const AddEdgeDialog = ({ open, graphInfo, onClose }: Props): JSX.Element => {
  const { t } = useTranslation();

//  const [name, setName] = useState('');
//  const [parameters, updateParameters, resetParameters] = useComplexObject<SelectedValueType>({});
  const [error, setError] = useState(false);
  const [existenceError, setExistenceError] = useState(false);
  const [serviceFrom, setServiceFrom] = useState('');
  const [servicesTo, setServicesTo] = useState([] as string[]);
  const [servicesToIDs, setServicesToIDs] = useState([] as string[]);
  const [serviceFromID, setServiceFromID] = useState('');
//  const [servicesFrom, setServicesFrom] = useState(graphInfo?.nodes as INode[] | null);
//  const [servicesTo, setServicesTo] = useState(graphInfo?.nodes as INode[] | null);
  const array = graphInfo?.nodes;
  const graphEdges = graphInfo?.edges;
  //.forEach(node => console.log(node.id));
  const nodesInfo = [array?.map(node => node.title), array?.map(node => node.id)]; // 2 rows: First with names of services, Second with IDs
  const nodesIDs = array?.map(node => node.id);
//  console.log(array?.map(node => node.title));
//  console.log(nodesInfo[0]);

  const reset = () => {
    //setName('');
    setExistenceError(false);
    setError(false);
    setServiceFrom('');
    setServicesTo([]);
    setServiceFromID('');
    setServicesToIDs([]);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
//  useEffect(reset, [serviceFrom, servicesTo]);

  const handleClose = (success: boolean) => () => {
    setExistenceError(false);
    if (success) {
      const ExistingEdges = graphEdges?.filter(edge => (((edge.source + '_' + edge.target) === (serviceFromID + '_' + servicesToIDs)) || ((edge.source + '_' + edge.target) === (servicesToIDs + '_' + serviceFromID))));
      if (ExistingEdges && ExistingEdges.length >= 1) {
        setExistenceError(true);
        return;
      }
    }
    onClose(success, serviceFromID, servicesToIDs);
    reset();
  };

//  const handleParameterChange = (parameter: string) => (value: SelectedValueType) => updateParameters(parameter, value);
//  let menuEntries: JSX.Element[];
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const handleChangeFrom = (event: SelectChangeEvent<typeof serviceFrom>) => {
    const {
      target: { value },
    } = event;
    let IDsPartRaw = '';
    const idx = nodesInfo[0]?.findIndex((element) => (element===value)); // index of each chosen variable in list of nodes
    if (nodesIDs && idx || nodesIDs && idx===0) {
      IDsPartRaw = String(nodesIDs[idx]);
    }
    setServiceFrom(value);
    setServiceFromID(IDsPartRaw); 
  };

  const handleChangeTo = (event: SelectChangeEvent<typeof servicesTo>) => {
    const {
      target: { value },
    } = event;
    const IDsPartRaw: string | string[] = [];
    Object.entries(value).forEach(value0 => {
      const idx = nodesInfo[0]?.findIndex((element) => (element===value0[1])); // index of each chosen variable in list of nodes
      if (nodesIDs && idx || nodesIDs && idx===0) {
        IDsPartRaw.push(String(nodesIDs[idx]));
      }
    });
    setServicesTo(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
    setServicesToIDs(IDsPartRaw);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose(false)}
      aria-labelledby={'add-edge-dialog-title'}
      aria-describedby={'add-edge-dialog-description'}
      fullWidth={true}
      maxWidth={'md'}
      TransitionComponent={UpTransition}
    >
      {(
        <div className='addEdge-dialog'>
          <DialogTitle id={'add-edge-dialog-title'}>
            Edge hinzufügen
          </DialogTitle>
          <DialogContent>
            {/*<TextField
              variant={'filled'}
              label={t('Name')}
              value={name}
              onChange={event => setName(event.target.value)}
              fullWidth
            /> */}
            <InputLabel id="service-from-select-label">From Service</InputLabel>
            <Select
              labelId="service-from-select-label"
              id="service-from-select"
              value={serviceFrom}
              label="From Service"
              onChange={handleChangeFrom}
              autoWidth
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  <Chip key={selected} label={selected} />
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {nodesInfo[0]?.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox checked={serviceFrom.indexOf(name) > -1} />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
            <InputLabel id="service-to-select-label">To Service(s)</InputLabel>
            <Select
              labelId="service-to-select-label"
              id="service-to-select"
              multiple
              value={servicesTo}
              label="To Service"
              onChange={value => handleChangeTo(value)}
              autoWidth
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value, i) => (
                  <Chip key={i} label={value} />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {nodesInfo[0]?.map((name, i) => ( 
                <MenuItem key={i} value={name}>
                  <Checkbox checked={servicesTo.indexOf(name) > -1} />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
            {error && <ErrorTypography message={'Bitte Angaben überprüfen'} />}
            {existenceError && <ErrorTypography message={'Diese zwei Knoten sind schon verbunden'} />}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose(false)}>
              <Trans>Cancel</Trans>
            </Button>
            <Button onClick={handleClose(true)}>
              <Trans>Create Edge</Trans>
            </Button>
          </DialogActions>
        </div>
      )}
    </Dialog>
  );
};

export default AddEdgeDialog;